import React from "react";
import {
  MdFilterList,
  MdCenterFocusStrong,
  MdBrokenImage,
  MdDateRange,
  MdInfo,
  MdTrendingUp,
  MdLinearScale,
} from "react-icons/md";
import {
  Box,
  Text,
  SimpleGrid,
  AccordionItem,
  AccordionPanel,
  AccordionIcon,
  Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  Checkbox,
  AccordionButton,
  Tooltip,
} from "@chakra-ui/react";
import * as constants from "@uidaholib/shared/constants/constants";
import FeatureIcon from "./feature-icon";
import { observer } from "mobx-react-lite";
import { featureStore } from "@uidaholib/shared/models/features/features";
import { take } from "ramda";

const Filter = observer(
  ({ field, icon, title, defaultTitle, features, hasDetail, detail }) => {
    const selected = take(
      3,
      features.filter((f) => f.selected)
    );
    return (
      <Popover placement="bottom-start" gutter={0}>
        <PopoverTrigger>
          <Box bg="white" boxShadow="md" borderRadius="md">
            <Flex alignContent="center" p={2} borderTopRadius="md">
              <Box as={icon} boxSize={6} mr={2} />
              <Text>{defaultTitle ? defaultTitle : title}</Text>
            </Flex>
            <Box p={2} bg="gray.100" borderBottomRadius="md">
              {selected.length > 0 ? (
                <Flex>
                  {selected.map((s) => (
                    <span key={s.label}>
                      {s.label.toString().substring(0, 4)}
                      <i>{", "}</i>
                    </span>
                  ))}
                </Flex>
              ) : (
                <span>No Selection</span>
              )}
            </Box>
          </Box>
        </PopoverTrigger>
        <PopoverContent p={2} borderRadius="md" shadow="md" zIndex={45}>
          <SimpleGrid columns={features.length <= 2 ? 1 : 3} spacing={2}>
            {features.map((feature) => (
              <FeatureIcon
                feature={feature}
                field="selected"
                key={feature.label}
              />
            ))}
          </SimpleGrid>
          {hasDetail && detail()}
        </PopoverContent>
      </Popover>
    );
  }
);

const filterIcons = {
  [constants.RESOLUTION]: MdFilterList,
  [constants.RECTIFICATION]: MdBrokenImage,
  [constants.ACQ_YEAR_LAST]: MdDateRange,
  [constants.PRO_DEF]: MdBrokenImage,
  [constants.DEM_TYPE]: MdTrendingUp,
  [constants.SCALE]: MdLinearScale,
};


const Filters = observer(() => {
  const filters = featureStore.getFilters();

  return (
    <>
      <AccordionButton>
        <Box flex="1" textAlign="left">
          <Flex alignItems="center">
            <Box as={MdFilterList} mr={2} boxSize={6} />
            <Text fontSize="sm" fontWeight="bold" textTransform="uppercase">
              Filters
            </Text>
          </Flex>
        </Box>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel pb={4}>
        <SimpleGrid columns={2} spacing={3}>
          {filters.every((f) => f.length > 0) &&
            filters.map((features) => (
              <Filter
                key={`${features[0].title}${features[0].id}`}
                icon={filterIcons[features[0].fieldName]}
                title={features[0].title}
                defaultTitle={
                  features[0].fieldName === constants.ACQ_YEAR_LAST
                    ? "Acquisition Year"
                    : null
                }
                features={features}
                hasDetail={features[0].fieldName === constants.ACQ_YEAR_LAST}
                detail={() => (
                  <Box p={2}>
                    <Text color="gray.600">
                      <b>Note:</b> If the layer contains images from multiple
                      years, this is the year of the most recent image in the layer.
                    </Text>
                  </Box>
                )}
                field="selected"
              />
            ))}
        </SimpleGrid>
      </AccordionPanel>
    </>
  );
});

export default Filters;
